import { create } from 'zustand';

export type Theme = 'dark' | 'light';

interface ThemeState {
  theme: Theme;
  toggle: () => void;
}

// public/theme-boot.js sets data-theme before the first paint.
const initial: Theme = document.documentElement.dataset.theme === 'light' ? 'light' : 'dark';

/** Colors the browser bar, or the title bar of the installed app, like the panels. */
function applyThemeColor(): void {
  const panel = getComputedStyle(document.documentElement).getPropertyValue('--panel').trim();
  if (panel) document.querySelector('meta[name="theme-color"]')?.setAttribute('content', panel);
}
applyThemeColor();

export const useTheme = create<ThemeState>((set) => ({
  theme: initial,
  toggle: () =>
    set((s) => {
      const theme: Theme = s.theme === 'dark' ? 'light' : 'dark';
      document.documentElement.dataset.theme = theme;
      applyThemeColor();
      try {
        localStorage.setItem('mv-theme', theme);
      } catch {
        // Storage may be blocked; the theme still applies for this visit.
      }
      return { theme };
    }),
}));
